var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Resolve kinds, list catalog entries, look up metadata.
 */
import { SCHEMATIC_CATALOG } from './catalog';
import { SCHEMATIC_ALIASES } from './aliases';
var KIND_SET = new Set(SCHEMATIC_CATALOG.map(function (r) { return r[0]; }));
export function resolveSchematicSymbolKind(input) {
    var raw = String(input || '')
        .trim()
        .replace(/[\s-]+/g, '_');
    var lower = raw.toLowerCase();
    if (KIND_SET.has(raw))
        return raw;
    if (SCHEMATIC_ALIASES[raw])
        return SCHEMATIC_ALIASES[raw];
    if (SCHEMATIC_ALIASES[lower])
        return SCHEMATIC_ALIASES[lower];
    if (KIND_SET.has(lower))
        return lower;
    var camel = lower.replace(/_([a-z])/g, function (_, c) { return c.toUpperCase(); });
    if (KIND_SET.has(camel))
        return camel;
    if (SCHEMATIC_ALIASES[camel])
        return SCHEMATIC_ALIASES[camel];
    return 'resistor';
}
export function listSchematicSymbols(category) {
    return SCHEMATIC_CATALOG.filter(function (_a) {
        var _b = __read(_a, 3), cat = _b[2];
        return !category || cat === category;
    }).map(function (_a) {
        var _b = __read(_a, 3), kind = _b[0], label = _b[1], cat = _b[2];
        return ({
            kind: kind,
            label: label,
            category: cat,
        });
    });
}
export function listSchematicSymbolCategories() {
    var e_1, _a;
    var seen = new Set();
    var out = [];
    try {
        for (var SCHEMATIC_CATALOG_1 = __values(SCHEMATIC_CATALOG), SCHEMATIC_CATALOG_1_1 = SCHEMATIC_CATALOG_1.next(); !SCHEMATIC_CATALOG_1_1.done; SCHEMATIC_CATALOG_1_1 = SCHEMATIC_CATALOG_1.next()) {
            var _b = __read(SCHEMATIC_CATALOG_1_1.value, 3), cat = _b[2];
            if (!seen.has(cat)) {
                seen.add(cat);
                out.push(cat);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (SCHEMATIC_CATALOG_1_1 && !SCHEMATIC_CATALOG_1_1.done && (_a = SCHEMATIC_CATALOG_1.return)) _a.call(SCHEMATIC_CATALOG_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
export function getSchematicSymbolMeta(kind) {
    var resolved = resolveSchematicSymbolKind(kind);
    var row = SCHEMATIC_CATALOG.find(function (_a) {
        var _b = __read(_a, 1), k = _b[0];
        return k === resolved;
    });
    if (row)
        return { kind: row[0], label: row[1], category: row[2] };
    return { kind: resolved, label: resolved, category: 'misc' };
}
